import api from '../../../../helpers/api';

export const getSectorsSocioeconomicDemographic = (payload) => {
  return api.post(`developer/platform/adsky/census_sectors`, payload);
};

export const getBigNumbersSocioeconomicDemographic = (payload) => {
  return api.post(`developer/platform/family-income/big-numbers`, payload);
};

export const getInfoWindowSocioeconomicDemographic = (payload) => {
  return api.post(`developer/platform/family-income/info-window`, payload);
};
